import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.trendData = JSON.parse(JSON.stringify(this.DataItems))
      this.weekData = JSON.parse(JSON.stringify(this.Queries.SQL1))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.current = 'C'


      // JQueries
      this.ref           = json.ref
      this.items         = json.items
      this.title         = json.title
      this.timeline      = {...json.timeline, axis: null, xItems: []}
      this.primary       = {...json.primary, axis: null, max: null}
      this.trend         = json.trend
      this.week          = json.week
      this.keys          = json.keys
      this.trendfilters  = json.trendfilters
      this.weekfilters   = json.weekfilters
      this.sundries      = json.sundries

      this.weekData.forEach(d=> {
        d.filter = this.week.ref.find(f=> f.week == d.WEEK).filter
      })

      

      // Setting Timeline ------------------------------
      let unique = [ ...new Set(this.trendData.filter(f=> f[this.ref.item]==this.current).map(m => m[this.ref.timeline])) ]
      this.timeline.axis = d3.scaleBand()
      .domain(unique)
      .range([0, this.trend.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      unique.forEach((d,i)=> {
        
        let mid = this.timeline.axis(d) + this.timeline.band / 2
        this.timeline.xItems.push({
          name: d,
          sx: this.timeline.axis(d),
          mx: mid,
          ex: this.timeline.axis(d) + this.timeline.band
        })
      })


      this.refresh_Chart()
    },


  }
}